import React from 'react'
import PropTypes from 'prop-types'
import { VISA_ICON, MASTERCARD_ICON } from './assets/Icons'

const styles = {
  icon: {
    height: 'auto',
    width: '2.858em'
  }
}

const CardIcon = ({ icon }) => {
  switch (icon) {
    case 'VISA':
      return <img src={VISA_ICON} alt='visa-icon' style={styles.icon} />
    case 'MASTERCARD':
      return (
        <img src={MASTERCARD_ICON} alt='mastercard-icon' style={styles.icon} />
      )
    default:
      return null
  }
}

CardIcon.propTypes = {
  icon: PropTypes.string.isRequired
}

const Card = ({ type }) => <CardIcon icon={type} />

Card.propTypes = {
  type: PropTypes.string.isRequired
}

export default Card
